import React from "react";
import PrimaryCard from "../../../../components/cards/PrimaryCard";

interface StatCardProps {
  icon?: React.ComponentType<{ className?: string }>;
  value: string | number;
  label: string;
  iconBg?: string;
  className?: string; // ⬅️ added
}

const StatCard: React.FC<StatCardProps> = ({
  icon: Icon,
  value,
  label,
  iconBg = "bg-gray-100",
  className = "", // ⬅️ added
}) => (
  <PrimaryCard className={className}>
    {" "}
    {/* ⬅️ apply className */}
    <div className="flex items-center justify-between">
      <div>
        <p className="text-lg font-bold text-gray-900"> {value}</p>
        <p className="text-sm text-gray-600 mt-1">{label}</p>
      </div>

      <div className={`${iconBg} p-2 rounded-lg`}>
        {Icon && <Icon className="w-6 h-6 text-gray-700" />}
      </div>
    </div>
  </PrimaryCard>
);

export default StatCard;
